// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CloudDownloadIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CloudDownload/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6 13a4 4 0 0 1 0-8 4 4 0 1 1 8 0 4 4 0 0 1 0 8h-3V8a1 1 0 1 0-2 0v5H6ZM9 13h2v2.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L9 15.586V13Z"
}));
export default CloudDownloadIcon;